const cleanText = (v) => (v == null ? "" : String(v).trim());
const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
};

const normalizarTipoComp = (tipo, serie = "") => {
  const t = cleanText(tipo).toUpperCase();
  const s = cleanText(serie).toUpperCase();
  if (t === "14" || t === "RECIBO" || s === "SB01") return "14";
  if (t === "03" || t === "BOLETA") return "03";
  if (t === "07" || t === "NOTA_CREDITO") return "07";
  if (t === "08" || t === "NOTA_DEBITO") return "08";
  return "01";
};

const buildDocumentKey = (doc) => {
  const tipo = normalizarTipoComp(doc.tipoComprobante || doc.tipo_comprobante || doc.tipo, doc.serie);
  const serie = cleanText(doc.serie).toUpperCase();
  const numeroRaw = cleanText(doc.numero).toUpperCase();
  const numeroClean = numeroRaw.replace(/^0+/, "") || "0";

  return `${tipo}|${serie}|${numeroClean}`;
};

export const conciliarComprobantes = ({ locales = [], propuestaSunat = [], tipo = "RCE" }) => {
  const normalizedTipo = cleanText(tipo).toUpperCase();
  const mapSunat = new Map();
  const mapLocales = new Map();

  propuestaSunat.forEach((item) => {
    const key = buildDocumentKey(item);
    mapSunat.set(key, item);
  });

  locales.forEach((item) => {
    const key = buildDocumentKey(item);
    mapLocales.set(key, item);
  });

  const coincidenciasExactas = [];
  const diferenciasImportes = [];
  const soloLocales = [];
  const soloSunat = [];

  // Recorrer comprobantes locales
  mapLocales.forEach((itemLocal, key) => {
    if (mapSunat.has(key)) {
      const itemSunat = mapSunat.get(key);
      const totalLocal = toNum(itemLocal.total ?? itemLocal.importes?.total ?? itemLocal.montos?.total);
      const totalSunat = toNum(itemSunat.total ?? itemSunat.importes?.total ?? itemSunat.montos?.total);
      const diffTotal = Math.abs(totalLocal - totalSunat);

      if (diffTotal < 0.05) {
        coincidenciasExactas.push({
          key,
          tipo: normalizedTipo,
          local: itemLocal,
          sunat: itemSunat,
          estado: "COINCIDENCIA_EXACTA",
          diferenciaMonto: 0,
        });
      } else {
        diferenciasImportes.push({
          key,
          tipo: normalizedTipo,
          local: itemLocal,
          sunat: itemSunat,
          estado: "DIFERENCIA_IMPORTES",
          diferenciaMonto: toNum(totalLocal - totalSunat),
        });
      }
    } else {
      soloLocales.push({
        key,
        tipo: normalizedTipo,
        local: itemLocal,
        sunat: null,
        estado: "SOLO_LOCAL",
        diferenciaMonto: toNum(itemLocal.total ?? itemLocal.importes?.total ?? itemLocal.montos?.total),
      });
    }
  });

  // Recorrer comprobantes de SUNAT que no estén en local
  mapSunat.forEach((itemSunat, key) => {
    if (!mapLocales.has(key)) {
      soloSunat.push({
        key,
        tipo: normalizedTipo,
        local: null,
        sunat: itemSunat,
        estado: "SOLO_SUNAT",
        diferenciaMonto: toNum(itemSunat.total ?? itemSunat.importes?.total ?? itemSunat.montos?.total),
      });
    }
  });

  const totalLocalesCount = locales.length;
  const totalSunatCount = propuestaSunat.length;
  const conciliadoOk = diferenciasImportes.length === 0 && soloLocales.length === 0 && soloSunat.length === 0;

  return {
    tipo: normalizedTipo,
    conciliadoOk,
    resumen: {
      totalLocales: totalLocalesCount,
      totalSunat: totalSunatCount,
      coincidenciasExactas: coincidenciasExactas.length,
      diferenciasImportes: diferenciasImportes.length,
      soloLocales: soloLocales.length,
      soloSunat: soloSunat.length,
    },
    coincidenciasExactas,
    diferenciasImportes,
    soloLocales,
    soloSunat,
    todos: [...coincidenciasExactas, ...diferenciasImportes, ...soloLocales, ...soloSunat],
  };
};
